import { render, staticRenderFns } from "./FridgeSOReport.vue?vue&type=template&id=af24fe54&"
import script from "./FridgeSOReport.vue?vue&type=script&lang=js&"
export * from "./FridgeSOReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports